"use client";

import { c as _c } from "react/compiler-runtime";
import type { ActivityLogParams } from "@/components/profile-activity/ProfileActivityLogs";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { useIdentity } from "@/hooks/useIdentity";
import { useParams } from "next/navigation";
import type { ProfileRatersParams } from "../utils/raters-table/wrapper/ProfileRatersTableWrapper";
import UserPageSetUpProfileWrapper from "../utils/set-up-profile/UserPageSetUpProfileWrapper";
import UserPageIdentity from "./UserPageIdentity";
export default function UserPageIdentityWrapper(t0) {
  const $ = _c(13);
  const {
    profile: initialProfile,
    initialCICReceivedParams,
    initialCICGivenParams,
    initialActivityLogParams
  } = t0;
  const params = useParams();
  let t1;
  if ($[0] !== params?.user) {
    t1 = (params?.user as string)?.toLowerCase();
    $[0] = params?.user;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const user = t1;
  let t2;
  if ($[2] !== initialProfile || $[3] !== user) {
    t2 = {
      handleOrWallet: user,
      initialProfile
    };
    $[2] = initialProfile;
    $[3] = user;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    profile
  } = useIdentity(t2);
  const t3 = profile ?? initialProfile;
  const t4 = profile ?? initialProfile;
  let t5;
  if ($[5] !== initialActivityLogParams || $[6] !== initialCICGivenParams || $[7] !== initialCICReceivedParams || $[8] !== t4) {
    t5 = <UserPageIdentity profile={t4} initialCICReceivedParams={initialCICReceivedParams} initialCICGivenParams={initialCICGivenParams} initialActivityLogParams={initialActivityLogParams} />;
    $[5] = initialActivityLogParams;
    $[6] = initialCICGivenParams;
    $[7] = initialCICReceivedParams;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <UserPageSetUpProfileWrapper profile={t3}>{t5}</UserPageSetUpProfileWrapper>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}